(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["desert-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('desert-personalization')) {
    customElements.define('desert-personalization', class extends HTMLElement {
      connectedCallback() {
        this.syncVariant();
        this.onchange = (event) => {
          if (event.target.matches('[data-design-image]')) {
            const file = event.target.files[0];
            event.target.setCustomValidity(file && file.size > 5 * 1024 * 1024 ? 'Choose an image smaller than 5 MB.' : '');
            event.target.reportValidity();
          }
          const select = this.querySelector('[data-monogram-select]');
          const preview = this.querySelector('[data-monogram-preview]');
          if (!select || !preview) return;
          const url = select.selectedOptions[0]?.dataset.preview;
          preview.hidden = !url;
          if (url) preview.src = url;
        };
      }
      syncVariant() {
        const fields = this.querySelector('[data-monogram-fields]');
        const variant = this.closest('form')?.querySelector('[name="id"]')?.value;
        const enabled = variant === this.dataset.monogramVariant;
        if (fields) {
          fields.disabled = !enabled;
          fields.hidden = !enabled;
        }
        const designFields = this.querySelector('[data-design-fields]');
        if (designFields) {
          const designEnabled = this.dataset.wallArt === 'true' || variant === this.dataset.designVariant;
          designFields.disabled = !designEnabled;
          designFields.hidden = !designEnabled;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
